import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Action } from 'redux';
import { SET_MENU_OPENED } from '../actions';
import { Actions } from '@webapp/store/actions';
import { CloseMenu, NoOp } from '../action-creators';

export const handlePageScrollEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Actions, CloseMenu>(SET_MENU_OPENED),
    map((action) => {
      if (!!action.menuId) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
      return new NoOp();
    })
  );
